import { css } from "@emotion/react";

const luxuryFont = `ui-serif, Playfair Display, Georgia, "Times New Roman", serif`;

export const page = css`
  width: 100vw;
  margin-left: calc(50% - 50vw);
  background: #f5f5f3;
  min-height: 100vh;
`;

export const inner = css`
  width: 100%;
  padding: 40px 56px 64px;

  @media (max-width: 1200px) {
    padding: 32px 24px 48px;
  }

  @media (max-width: 768px) {
    padding: 20px 16px 36px;
  }
`;

export const topLayout = css`
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(340px, 0.95fr);
  gap: 56px;
  align-items: start;

  @media (max-width: 1200px) {
    gap: 32px;
    grid-template-columns: minmax(0, 1fr) minmax(320px, 380px);
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const imageCol = css`
  width: 100%;
  min-width: 0;
`;

export const carouselWrap = css`
  width: 100%;
  background: #f1efea;
  overflow: hidden;

  .slick-slider,
  .slick-list,
  .slick-track {
    height: 100%;
  }

  .slick-dots {
    bottom: 14px;
  }

  .slick-dots li button::before {
    color: rgba(31, 31, 31, 0.45);
    font-size: 10px;
  }

  .slick-dots li.slick-active button::before {
    color: rgba(31, 31, 31, 0.9);
  }

  @media (max-width: 768px) {
    .slick-dots {
      bottom: 8px;
    }
  }
`;

export const image = css`
  width: 100%;
  height: 620px;
  object-fit: contain;
  display: block;
  background: #f1efea;

  @media (max-width: 1400px) {
    height: 560px;
  }

  @media (max-width: 1200px) {
    height: 500px;
  }

  @media (max-width: 1024px) {
    height: 420px;
  }

  @media (max-width: 900px) {
    height: 520px;
  }

  @media (max-width: 768px) {
    height: auto;
    aspect-ratio: 4 / 5;
    max-height: none;
  }
`;

export const infoCol = css`
  padding-top: 6px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;

  @media (max-width: 900px) {
    padding-top: 0;
  }

  @media (max-width: 768px) {
    align-items: stretch;
  }
`;

export const title = css`
  // margin: 0 0 16px;
  font-family: ${luxuryFont};
  font-size: 25px;
  line-height: 1.04;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1f1f1f;
  word-break: break-word;

  @media (max-width: 1200px) {
    font-size: 28px;
  }

  @media (max-width: 1024px) {
    font-size: 26px;
  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 24px;
    text-align: center;
    margin-bottom: 14px;
  }
`;

export const titleLine = css`
  width: 100%;
  max-width: 420px;
  height: 0.5px;
  background: #1f1f1f;
  margin: 0 0 16px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    max-width: none;
    margin-bottom: 14px;
  }
`;

export const description = css`
  margin: 0 0 10px;
  font-family: ${luxuryFont};
  font-size: 17px;
  line-height: 1.55;
  font-weight: 400;
  color: rgba(31, 31, 31, 0.82);

  @media (max-width: 1024px) {
    font-size: 16px;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    text-align: center;
  }
`;

export const moreDetailsLink = css`
  margin: 6px 0 18px;
  font-family: ${luxuryFont};
  font-size: 16px;
  line-height: 1.4;
  color: #1f1f1f;
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    align-self: center;
    margin-bottom: 14px;
  }
`;

export const reference = css`
  margin: 0 0 18px;
  font-family: ${luxuryFont};
  font-size: 16px;
  line-height: 1.4;
  color: rgba(31, 31, 31, 0.45);

  @media (max-width: 768px) {
    align-self: center;
    margin-bottom: 14px;
    text-align: center;
  }
`;

export const price = css`
  margin: 0 0 18px;
  font-family: ${luxuryFont};
  font-size: 30px;
  line-height: 1.1;
  font-weight: 600;
  color: #1f1f1f;

  @media (max-width: 1024px) {
    font-size: 30px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    align-self: center;
    margin-bottom: 14px;
    text-align: center;
  }
`;

export const metaRow = css`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
    gap: 8px;
    text-align: center;
    margin-bottom: 18px;
  }
`;

export const metaLabel = css`
  font-family: ${luxuryFont};
  font-size: 16px;
  color: rgba(31, 31, 31, 0.72);

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const metaValue = css`
  font-family: ${luxuryFont};
  font-size: 16px;
  color: #1f1f1f;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const swatches = css`
  display: flex;
  gap: 14px;
  margin: 0 0 28px;

  @media (max-width: 768px) {
    justify-content: center;
    width: 100%;
    margin-bottom: 22px;
  }
`;

export const swatch = css`
  width: 42px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(31, 31, 31, 0.18);
  overflow: hidden;
  background: transparent;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
`;

export const swatchInner = css`
  width: 100%;
  height: 100%;
  display: block;
`;

export const swatchGold = css`
  background: linear-gradient(135deg, #f1d591 0%, #c6a257 100%);
`;

export const swatchSilver = css`
  background: linear-gradient(135deg, #d7d7d7 0%, #8e8e8e 100%);
`;

export const buttonColumn = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: none;
    gap: 10px;
  }
`;

export const primaryButton = css`
  width: 100%;
  height: 52px;
  border: 1px solid #1f1f1f;
  background: #1f1f1f;
  color: #ffffff;
  cursor: pointer;

  font-family: ${luxuryFont};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  &:hover {
    opacity: 0.92;
  }

  @media (max-width: 768px) {
    height: 48px;
    font-size: 15px;
  }
`;

export const secondaryButton = css`
  width: 100%;
  height: 52px;
  border: 1px solid rgba(31, 31, 31, 0.45);
  background: transparent;
  color: #1f1f1f;
  cursor: pointer;

  font-family: ${luxuryFont};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  &:hover {
    background: #efede8;
  }

  @media (max-width: 768px) {
    height: 48px;
    font-size: 15px;
  }
`;

export const note = css`
  margin: 16px 0 0;
  max-width: 520px;
  font-family: ${luxuryFont};
  font-size: 15px;
  line-height: 1.5;
  color: rgba(31, 31, 31, 0.48);

  @media (max-width: 768px) {
    max-width: none;
    font-size: 14px;
    text-align: center;
  }
`;

export const detailsSection = css`
  margin: 64px auto 0;
  padding-top: 44px;
  border-top: 1px solid rgba(31, 31, 31, 0.12);
  max-width: 1200px;
  width: 100%;

  @media (max-width: 768px) {
    margin-top: 40px;
    padding-top: 32px;
  }
`;

export const detailsTitle = css`
  margin: 0 0 40px;
  font-family: ${luxuryFont};
  font-size: 20px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #1f1f1f;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 28px;
  }
`;

export const detailsGrid = css`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 48px 56px;
  justify-content: center;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px 24px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const detailItem = css`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const detailLabel = css`
  margin: 0;
  font-family: ${luxuryFont};
  font-size: 14px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #1f1f1f;
`;

export const detailValue = css`
  margin: 0;
  font-family: ${luxuryFont};
  font-size: 16px;
  line-height: 1.5;
  color: rgba(31, 31, 31, 0.82);

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

export const loadingBox = css`
  padding: 40px;
`;

export const errorBox = css`
  max-width: 700px;
  margin: 40px auto;
`;
